import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useInstantSearch, useCurrentRefinements, Configure } from 'react-instantsearch';
import { InfinitePagination } from '@grandvisionhq/common';
import { useLocation } from '@grandvisionhq/frk-routing';
import { useIsClient } from '@grandvisionhq/lib-utils-react';
import { useIntl } from '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import { useItemsToClear } from '../Algolia/hooks/use-items-to-clear.js';
import '../types.js';
import '@grandvisionhq/utils';
import 'lodash/orderBy';
import 'classnames';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import { useAlgoliaConfig } from '../Algolia/AlgoliaConfig.js';
import 'lodash/uniqBy';
import '@grandvisionhq/iris-ui';
import 'motion/react';
import '../Algolia/utils/query-string.js';
import { useAlgoliaData } from '../Algolia/hooks/use-algolia-data.js';
import '../Algolia/AlgoliaAnalytics.js';
import '@grandvisionhq/fun-products';
import '@grandvisionhq/products';
import 'algoliasearch/lite';
import '../CrossSellProducts/utils/create-algolia-filters.js';
import 'instantsearch.js/cjs/lib/routers/history';
import 'lodash/merge';
import 'react-dom/server';
import '../Algolia/enrich-algolia-config.js';

const ConnectedInfinitePagination = ({ labelKey  })=>{
    const isMounted = useIsClient();
    const { setIndexUiState  } = useAlgoliaData();
    const { results: { nbHits: total  } , status ,  } = useInstantSearch();
    const isLoading = status === 'loading';
    const { getLabel  } = useIntl();
    const { pageSize  } = useAlgoliaConfig();
    const { items  } = useCurrentRefinements();
    const itemsFiltered = useItemsToClear(items);
    const itemsFilteredRef = React.useRef(itemsFiltered);
    const { query  } = useLocation();
    var ref;
    const page = Number((ref = query.get('page')) !== null && ref !== void 0 ? ref : 1);
    const [length, setLength] = React.useState(page * pageSize);
    React.useEffect(()=>{
        // In order to not make excessive calls to Algolia, we only want to run this when
        // page > 1. Additionally, we cannot trust page number from Algolia state, as our page
        // number is derived from length and offsets, so we use page querystring for this.
        if (itemsFiltered.length !== itemsFilteredRef.current.length && page > 1) {
            setIndexUiState((prev)=>swcHelpers.objectSpread({}, prev, {
                    configure: swcHelpers.objectSpread({}, prev.configure, {
                        length: pageSize,
                        offset: 0,
                        page: 1
                    })
                })
            );
            setLength(pageSize);
        }
        itemsFilteredRef.current = itemsFiltered;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        itemsFiltered,
        page
    ]);
    const handleClick = ()=>{
        /**
     * Here we limit the length size to max of 1000.
     * By default Algolia will only allow 1000 hits for better performance
     * unless we change it.
     * https://www.algolia.com/doc/guides/building-search-ui/ui-and-ux-patterns/infinite-scroll/js/#show-more-than-1000-hits
     */ const newLength = Math.min(length + pageSize, 1000);
        setLength(newLength);
        /**
     * Configure component from algolia does not trigger algolia state changes,
     * so we have to do it ourselves. State change is needed for refinements to be converted
     * to URL query string params.
     */ setIndexUiState((prev)=>swcHelpers.objectSpread({}, prev, {
                configure: swcHelpers.objectSpread({}, prev.configure, {
                    length: newLength
                })
            })
        );
    };
    const currentPage = Math.round(length / pageSize);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isMounted ? /*#__PURE__*/ React.createElement(Configure, {
        offset: 0,
        length: length
    }) : null, /*#__PURE__*/ React.createElement(InfinitePagination, {
        onClick: handleClick,
        buttonLabel: getLabel('search.loadMore'),
        labelKey: labelKey !== null && labelKey !== void 0 ? labelKey : 'search.pagingStatus',
        loaded: length,
        isLoading: isLoading,
        total: total,
        currentPage: currentPage
    }));
};

export { ConnectedInfinitePagination };
//# sourceMappingURL=InfinitePagination.js.map
